import { LegalEntityCountry } from '@seapoint/server/enums';
import { Drawer, DrawerContent } from '../../../../../design-system/drawer/drawer';
import { Stack } from '../../../../../design-system/stack/stack';
import { BeneficiaryView, EmployeeView } from '../../../../../types/entity-types';
import { EmployeeExtendedRequestType } from '../../../hooks/use-employee';
import { EmployeeDrawerMode } from '../../../use-payroll-flow';
import { createAddressObject, createDestinationObject } from '../../../utils/employee-drawer-helpers';
import { EmployeeForm, EmployeeFormValues } from './employee-form';

type EmployeeDrawerProps = {
  isOpen: boolean;
  mode: EmployeeDrawerMode;
  selectedEmployeeId: string | null;
  employee?: EmployeeView;
  legalEntityCountry: LegalEntityCountry;
  companyId: string;
  onClose: () => void;
  onSave: (formData: EmployeeExtendedRequestType) => void;
  isSubmitting?: boolean;
  beneficiaries?: BeneficiaryView[];
};

export const EmployeeDrawer = ({
  isOpen,
  employee,
  legalEntityCountry,
  mode,
  companyId,
  onClose,
  onSave,
  isSubmitting = false,
  beneficiaries = [],
}: EmployeeDrawerProps) => {
  const showBottomSaveButton = mode === 'ADD' || mode === 'EDIT';

  const handleSave = (formData: EmployeeFormValues) => {
    const address = createAddressObject(formData);
    const destination = createDestinationObject(formData);
    onSave({ ...formData, address, destination, companyId });
  };

  return (
    <Drawer open={isOpen} onOpenChange={onClose} direction="right" modal={true}>
      <DrawerContent className="h-full overflow-x-hidden overflow-y-auto" aria-describedby={undefined}>
        <Stack space={3} className="h-full w-full overflow-x-hidden overflow-y-auto">
          <EmployeeForm
            mode={mode}
            legalEntityCountry={legalEntityCountry}
            employee={employee}
            beneficiaries={beneficiaries}
            onSubmit={handleSave}
            showBottomSaveButton={showBottomSaveButton}
            isSubmitting={isSubmitting}
            onClose={onClose}
          />
        </Stack>
      </DrawerContent>
    </Drawer>
  );
};
